// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"90f80f3e","453":"7a5c943b","934":"9e3c20d8"}[chunkId] + ".chunk.js";
};